var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.892,
    height: 47.837,
    viewBox: "0 0 40.892 47.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9042800_page_edit_icon",
    "data-name": "9042800_page_edit_icon",
    transform: "translate(-2.75 -0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M40.2,24.624V10.48a1.358,1.358,0,0,0-.4-.96L32.677,2.4a1.357,1.357,0,0,0-.96-.4H5.357A1.357,1.357,0,0,0,4,3.357V45.89a1.357,1.357,0,0,0,1.357,1.357H19.836",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M8,15.049H26.1M8,6h9.049M8,24.1h6.787",
    transform: "translate(5.049 5.049)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M16,9.692V2.8a.8.8,0,0,1,1.366-.566l7.449,7.45a.8.8,0,0,1-.566,1.365H17.357A1.357,1.357,0,0,1,16,9.692Z",
    transform: "translate(15.148 0)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M22.391,18.616l2.262-2.262a2.537,2.537,0,0,1,3.588,0h0a2.537,2.537,0,0,1,0,3.588L25.979,22.2m-3.588-3.588-6.767,6.767a2.262,2.262,0,0,0-.635,1.251l-.549,3.521,3.521-.549a2.263,2.263,0,0,0,1.251-.636L25.979,22.2m-3.588-3.588L25.979,22.2",
    transform: "translate(13.178 17.182)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.e905a0a59a29f74ec7f9a771c3c857f7.svg";
export { ForwardRef as ReactComponent };